import Bugsnag from "@bugsnag/js";
import { DEFAULT_NOTIFICATION_PAYLOAD, NOTIFICATION_VARIANTS } from "@/utils/applicationConstants";
import { sendAnalytics } from "@/utils/analytics";
import { showNotification } from "@/redux/actions/notification";
import { borrowerService } from "@/modules/contacts/features/borrower/store/services/borrower-service";
import { BORROWER_SERVICE_TAG } from "@/modules/contacts/features/borrower/utils/borrower-service-tags";
import { BORROWER_ANALYTIC_EVENTS } from "@/modules/contacts/features/borrower/utils/borrower-analytic-events";
import { LIST_SERVICE_TAG } from "@/shared/store/service/commonServiceTags";
import { CONTACT_SERVICE_TAG } from "@/modules/contacts/utils/contact-service-tags";
import { contactService } from "@/modules/contacts/store/services/contact-service";
import { dashboardService } from "@/redux/services/dashboardService";

const deleteBorrower = borrowerService.injectEndpoints({
  endpoints: builder => ({
    deleteBorrower: builder.mutation({
      query(id) {
        return {
          url: `borrowers/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: [{ type: BORROWER_SERVICE_TAG, id: LIST_SERVICE_TAG }],
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          sendAnalytics(BORROWER_ANALYTIC_EVENTS.BORROWER_DELETED, data);
          dispatch(
            showNotification({
              ...DEFAULT_NOTIFICATION_PAYLOAD,
              message: {
                ...DEFAULT_NOTIFICATION_PAYLOAD.message,
                description: "Borrower has been deleted!",
                options: {
                  variant: NOTIFICATION_VARIANTS.SUCCESS,
                },
              },
            }),
          );
          dispatch(contactService.util.invalidateTags([CONTACT_SERVICE_TAG]));
          dispatch(dashboardService.util.invalidateTags([{ type: "Dashboard.OutstandingNeedsList", id: "LIST" }]));
          dispatch(dashboardService.util.invalidateTags([{ type: "Dashboard.ReviewNeedsList", id: "LIST" }]));
        } catch (err) {
          Bugsnag.notify(err);
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useDeleteBorrowerMutation } = deleteBorrower;

